import type { CollaborationPresenceUser } from '@/hooks/use-collaboration-presence';
import { PresenceAvatarStack } from './presence-avatar-stack';

type NodePresenceIndicatorProps = {
    users: CollaborationPresenceUser[];
};

export function NodePresenceIndicator({ users }: NodePresenceIndicatorProps) {
    if (users.length === 0) {
        return null;
    }

    return (
        <div
            className="absolute -left-10 bottom-0 z-20 flex items-center gap-1"
            contentEditable={false}
        >
            <PresenceAvatarStack
                users={users}
                maxVisible={3}
                size="sm"
                ariaLabel="Editors in this node"
                direction="column"
            />
        </div>
    );
}

export default NodePresenceIndicator;
